var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.66671 29.75H7.08337V11.3333H5.66671C4.91526 11.3333 4.19459 11.6319 3.66324 12.1632C3.13188 12.6946 2.83337 13.4152 2.83337 14.1667V26.9167C2.83337 27.6681 3.13188 28.3888 3.66324 28.9201C4.19459 29.4515 4.91526 29.75 5.66671 29.75ZM28.3334 11.3333H18.4167L20.0062 6.56201C20.148 6.13618 20.1867 5.68275 20.1189 5.23906C20.0512 4.79538 19.879 4.37413 19.6166 4.01002C19.3542 3.64591 19.009 3.34935 18.6095 3.14478C18.21 2.9402 17.7676 2.83346 17.3188 2.83334H17L9.91671 10.5372V29.75H25.5L31.042 17.5723L31.1667 17V14.1667C31.1667 13.4152 30.8682 12.6946 30.3368 12.1632C29.8055 11.6319 29.0848 11.3333 28.3334 11.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.fbbc3175c369a9dfc5325a1abae47d38.svg";
export { ForwardRef as ReactComponent };